import * as actionTypes from './actiontypes';
import * as API from './api';
import { showMessage } from '../../config/utils';

export const updateAgentMonitoringState = (payload, path) => {
  return {
    type: actionTypes.UPDATE_AGENT_MONITORING_STATE,
    payload,
    path
  };
}

export const sendReportToEmailId = (payload, callback) => {
  return dispatch => {
    dispatch(updateAgentMonitoringState(true, 'loaders.report_sharing'));
    API.sendReportToEmailId(payload, (error, response) => {
      dispatch(updateAgentMonitoringState(false, 'loaders.report_sharing'));
      if (!error && response && response.message) {
        callback();
        showMessage('success', response.message)
      }
    });
  };
}


// WEBPACK FOOTER //
// ./src/data/redux/agent_monitoring_details/actions.js